import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { GenericLinkModule } from '../../generic-link/generic-link.module';
import { ProductSizeChartComponent } from './product-size-chart.component';

@NgModule({
  declarations: [ProductSizeChartComponent],
  imports: [CommonModule, I18nModule, GenericLinkModule, RouterModule, MatIconModule, UrlModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductSizeChartComponent: {
          component: ProductSizeChartComponent,
        },
      },
    }),
  ],
  exports: [ProductSizeChartComponent],
})
export class ProductSizeChartModule {}
